import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.ts';
import esTranslations from './locales/es.ts';
import frTranslations from './locales/fr.ts';
import itTranslations from './locales/it.ts';
import ptTranslations from './locales/pt.ts';

// Configure i18next
i18n
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  .init({
    fallbackLng: 'en',
    debug: false,
    
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    
    // language resources
    resources: {
      en: {
        translation: enTranslations
      },
      es: {
        translation: esTranslations
      },
      fr: {
        translation: frTranslations
      },
      it: {
        translation: itTranslations
      },
      pt: {
        translation: ptTranslations
      }
    }
  });

export default i18n;